import React, { useState, useEffect } from 'react'
import { createPortal } from 'react-dom';
import crossImg from './../../../assets/cross.svg';

const ErrorAlert = ({ children, timeout }) => {
  const [showElement, setShowElement] = useState(true)
  useEffect(()=>{
    const timer = setTimeout(() => {
      setShowElement(false)
    }, timeout);
    return () => clearTimeout(timer);
  }, [timeout]);

  return (
    createPortal(
        <>
          { showElement && <div className="p-2 text-sm text-white rounded-lg flex justify-center items-center bg-danger fixed top-[74px] left-0 right-0 m-auto text-center z-[99] max-w-[380px]">
            <img src={crossImg} alt="tick" className="w-6 h-6 inline-block mr-1" /> { children }
          </div> }
        </>,
        document.getElementById('alert')
    )
  )
}

export default ErrorAlert;